import React from "react";
import { Redirect } from "react-router-dom";

// Created By Cursor — merged into LeaveManagement
export default function StaffLeaveDetails() {
  return <Redirect to="/AdminMain/LeaveManagement?type=staff" />;
}
